import React, { useEffect } from "react";

function KakaoAd() {
  useEffect(() => {
    let ins = document.createElement("ins");
    let scr = document.createElement("script");

    ins.className = "kakao_ad_area";
    ins.style = "display:none; width:320";
    scr.async = "true";
    scr.type = "text/javascript";
    scr.src = "//t1.daumcdn.net/kas/static/ba.min.js";
    ins.setAttribute("data-ad-width", "320");
    ins.setAttribute("data-ad-height", "100");
    ins.setAttribute("data-ad-unit", "DAN-BMBrhchEZXNpy5pL");

    document.querySelector(".kakaoAdfit").appendChild(ins);
    document.querySelector(".kakaoAdfit").appendChild(scr);
  }, []);

  return <div className="kakaoAdfit"></div>;
}

export default KakaoAd;
